module.exports = __webpack_public_path__ + "static/img/lyh.675cf9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/lyh.png
// module id = 193E
// module chunks = 42